<template>
  <div class="bill-flow-view">
    <BillFlow />
  </div>
</template>

<script>
import BillFlow from '@/components/bill/BillFlow.vue'

export default {
  name: 'BillFlowView',
  components: {
    BillFlow
  }
}
</script>

<style scoped>
.bill-flow-view {
  flex: 1;
}
</style>
